import type { RequestConfig } from '@umijs/max';
import { history } from '@umijs/max';
import { getCurrentUser } from '@/services/auth';
import { getUserOptions } from '@/services/user';

import { errorConfig } from './requestErrorConfig';
import '@ant-design/v5-patch-for-react-19';

const loginPath = '/user/login';

if (typeof window !== 'undefined') {
  window.localStorage.setItem('umi_locale', 'zh-CN');
}

export type UserColorMap = Record<string, string>;

async function fetchUserColorMap(): Promise<UserColorMap> {
  try {
    const res = await getUserOptions();
    if (res?.code === 200 && Array.isArray(res.data)) {
      const map: UserColorMap = {};
      for (const u of res.data) {
        if (u?.id && u.avatarColor) map[u.id] = u.avatarColor;
      }
      return map;
    }
  } catch {
    // 静默失败，DefaultAvatar 会回退到 userId 哈希色
  }
  return {};
}

/**
 * @name getInitialState
 * @see https://umijs.org/docs/api/runtime-config#getinitialstate
 */
export async function getInitialState(): Promise<{
  currentUser?: any;
  loading?: boolean;
  fetchUserInfo?: () => Promise<any | undefined>;
  userColorMap?: UserColorMap;
  refreshUserColorMap?: () => Promise<UserColorMap>;
}> {
  const fetchUserInfo = async () => {
    try {
      const msg = await getCurrentUser({ skipErrorHandler: true });
      return msg.data;
    } catch (_error) {
      history.push(loginPath);
    }
    return undefined;
  };

  const pathname =
    typeof window !== 'undefined'
      ? window.location.pathname
      : history.location.pathname;
  const isNoAuthPath =
    pathname === loginPath ||
    pathname.startsWith('/user/') ||
    pathname.startsWith('/wechat/');

  if (!isNoAuthPath) {
    const [currentUser, userColorMap] = await Promise.all([
      fetchUserInfo(),
      fetchUserColorMap(),
    ]);
    return {
      fetchUserInfo,
      currentUser,
      userColorMap,
      refreshUserColorMap: fetchUserColorMap,
    };
  }
  return { fetchUserInfo, refreshUserColorMap: fetchUserColorMap };
}

/**
 * @name request 配置
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request: RequestConfig = {
  ...errorConfig,
};
